import styled from 'styled-components';
import colours from 'theme/atoms/colours';
import typography from 'theme/atoms/typography';

export const H1 = styled('h1')`
  ${typography.h1}
  color: ${colours.neutral[900]};
  margin: 0;
`;

export const H2 = styled('h2')`
  ${typography.h2}
  color: ${colours.neutral[900]};
  margin: 0;
`;

export const H3 = styled('h3')`
  ${typography.h3}
  color: ${colours.neutral[900]};
  margin: 0;
`;

export const H4 = styled('h4')`
  ${typography.h4}
  color: ${colours.neutral[900]};
  margin: 0;
`;

export const H5 = styled('h5')`
  ${typography.h5}
  color: ${colours.neutral[900]};
  margin: 0;
`;

export const H6 = styled('h6')`
  ${typography.h6}
  color: ${colours.neutral[900]};
  margin: 0;
`;

export const P1 = styled('p')`
  ${typography.p1}
  color: ${colours.neutral[900]};
  margin: 0;
`;

export const P1Semibold = styled(P1)`
  font-weight: 600;
`;

export const P1Bold = styled(P1)`
  font-weight: 650;
`;

export const P2 = styled('p')`
  ${typography.p2}
  color: ${colours.neutral[900]};
  margin: 0;
`;

export const P2Semibold = styled(P2)`
  font-weight: 600;
`;

export const P2Bold = styled(P2)`
  font-weight: 650;
`;

export const P3 = styled('p')`
  ${typography.p3}
  color: ${colours.neutral[900]};
  margin: 0;
`;

export const P3Semibold = styled(P3)`
  font-weight: 600;
`;

export const P3Bold = styled(P3)`
  font-weight: 650;
`;

export const Label = styled('p')`
  ${typography.label}
  color: ${colours.neutral[500]};
  margin: 0;
`;

export const LabelSemibold = styled(Label)`
  font-weight: 650;
`;
